import countries from '@/api/countries.json';

let codes = [];

export function countryCodes() {
  if (codes.length === 0) {
    codes = countries.map(({ code }) => code);
  }
  return codes;
}

let options = [];

export function countriesOptions() {
  if (options.length === 0) {
    options = countries.map(({ code, name_es }) => ({
      value: code,
      display: name_es,
    }));
  }
  return options;
}
